import { Directive, SimpleChange, Renderer2, OnDestroy, Injector, Input, OnInit } from '@angular/core';
import { DomicileService } from '../services/domicile.service';
import { EgonService } from '../services/egon.service'; 
import { Subscription, Observer, Observable, Subject } from 'rxjs';
import { switchMap, distinctUntilChanged , debounceTime , filter, tap } from 'rxjs/operators';
import { NgSelectComponent } from '@ng-select/ng-select';
import { NgControl, NgModel } from '@angular/forms';
import { Key } from 'ts-keycode-enum';
import { TypeaheadDirective, TypeaheadMatch } from 'ngx-bootstrap/typeahead';


@Directive({
  selector: '[street]',
  host: { 'class': 'dhl' }
})
export class StreetDirective implements OnInit, OnDestroy {
  private servicioDomicilio: DomicileService;
  @Input() mantenerValor = false;
  private suscriptionZipCode: Subscription;
  private suscripcionLocalidad: Subscription;
  private suscripcionOnSelect: Subscription;
  private busquedaFin: string;
  private calles: Array<string>;
  /** CalleConNumeroDirective */
  constructor(
    private injector: Injector,
    private servicioEgon: EgonService,
    private typeahead: TypeaheadDirective,
    private model: NgControl
  ) {
    typeahead.typeaheadMinLength = 0;
    typeahead.typeaheadWaitMs = 250;
    typeahead.typeaheadOptionsLimit = 1000;
    this.suscripcionOnSelect = typeahead.typeaheadOnSelect.subscribe(
      (match: TypeaheadMatch) => (this.busquedaFin = match.value)
    );
    this.typeahead.typeaheadAsync = true;
    let suscripcionCalles: Subscription;
    this.typeahead.typeahead = new Observable<string>((observer) =>{
    console.log(this.model.value)
      return observer.next(this.model.value)
    }).pipe(
      distinctUntilChanged(),
      debounceTime(100),
      filter(()=> {
        // console.log(this.servicioDomicilio.codigoPostal$.getValue());
        // console.log(this.servicioDomicilio.localidad$.getValue());
        console.log('CP', this.servicioDomicilio.zipCode$);
        console.log('Loc', this.servicioDomicilio.location$);
        const result = !!this.servicioDomicilio.zipCode$.getValue() &&
          !!this.servicioDomicilio.location$.getValue();
          console.log(result)
        return result;
      }),
      switchMap((busqueda: string) => {
        return new Observable<Array<string>>(
          (observer: Observer<Array<string>>) => {
            if (suscripcionCalles) {
              suscripcionCalles.unsubscribe();
            }
            suscripcionCalles = this.servicioEgon
              .streets(
                this.servicioDomicilio.location$.getValue(),                
                this.servicioDomicilio.localities$.getValue(),
                busqueda,                
              )
              .subscribe(
                (calles) => {
                  console.log(calles)
                  if (calles.length <= 1) {
                    // console.log('busqueda Fin', calles, busqueda)
                    this.busquedaFin = busqueda;
                  }
                  this.calles = calles;
                  observer.next(this.calles);
                },
                (err) => {
                  console.log(console.error);
                }
              );
            if (
              this.calles?.length === 1 &&
              busqueda &&
              busqueda.toLowerCase().startsWith(this.calles[0].toLowerCase())
            ) {
              observer.next([]);
            } else {
              if (this.calles?.length > 0) {
                if (busqueda) {
                  const filtradas = this.calles.filter((calle) =>
                    calle
                      .toLowerCase()
                      .normalize('NFD')
                      .replace(/\p{Diacritic}/gu, '')
                      .includes(busqueda.toLowerCase())
                  );
                  observer.next(filtradas);
                } else {
                  observer.next(this.calles);
                }
              }
            }
          }
        );
      })
    );
  }
  ngOnInit(): void {
    this.servicioDomicilio = this.injector.get(DomicileService);
    this.suscriptionZipCode =
      this.servicioDomicilio.zipCode$.subscribe(() => {
        this.clear();
      });
    this.suscripcionLocalidad = this.servicioDomicilio.location$.subscribe(
      (localidad) => {
        if (localidad) {
          this.model.control.enable();
        }
        // else {
        //   this.model.control.disable();
        // }
        this.clear();
      }
    );
  }
  ngOnDestroy(): void {
    if (this.suscripcionLocalidad) {
      this.suscripcionLocalidad.unsubscribe();
    }
    if (this.suscriptionZipCode) {
      this.suscriptionZipCode.unsubscribe();
    }
    if (this.suscripcionOnSelect) {
      this.suscripcionOnSelect.unsubscribe();
    }
  }

  /** Limpia el modelo */
  clear() {
    if (this.mantenerValor) {
      // this.mantenerValor = false;
      return;
    }
    this.model.reset();
  }
}
